import $icz4I$react, {useState as $icz4I$useState, useImperativeHandle as $icz4I$useImperativeHandle, Fragment as $icz4I$Fragment} from "react";
import $icz4I$reactdom from "react-dom";
import {VisuallyHidden as $icz4I$VisuallyHidden} from "@react-aria/visually-hidden";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $9694eec57086f168$exports = {};

$parcel$export($9694eec57086f168$exports, "announce", () => $9694eec57086f168$export$a9b970dcc4ae71a9);
$parcel$export($9694eec57086f168$exports, "clearAnnouncer", () => $9694eec57086f168$export$d10ae4f68404609a);
$parcel$export($9694eec57086f168$exports, "destroyAnnouncer", () => $9694eec57086f168$export$d8686216b8b81b2f);



/* Inspired by https://github.com/AlmeroSteyn/react-aria-live */ const $9694eec57086f168$var$LIVEREGION_TIMEOUT_DELAY = 7000;
let $9694eec57086f168$var$liveRegionAnnouncer = /*#__PURE__*/ $icz4I$react.createRef();
let $9694eec57086f168$var$node = null;
let $9694eec57086f168$var$messageId = 0;
function $9694eec57086f168$export$a9b970dcc4ae71a9(message, assertiveness = 'assertive', timeout = $9694eec57086f168$var$LIVEREGION_TIMEOUT_DELAY) {
    $9694eec57086f168$var$ensureInstance((announcer)=>announcer.announce(message, assertiveness, timeout)
    );
}
function $9694eec57086f168$export$d10ae4f68404609a(assertiveness) {
    $9694eec57086f168$var$ensureInstance((announcer)=>announcer.clear(assertiveness)
    );
}
function $9694eec57086f168$export$d8686216b8b81b2f() {
    if ($9694eec57086f168$var$liveRegionAnnouncer.current) {
        $icz4I$reactdom.unmountComponentAtNode($9694eec57086f168$var$node);
        document.body.removeChild($9694eec57086f168$var$node);
        $9694eec57086f168$var$node = null;
    }
}
/**
 * Ensures we only have one instance of the announcer so that we don't have elements competing.
 */ function $9694eec57086f168$var$ensureInstance(callback) {
    if (!$9694eec57086f168$var$liveRegionAnnouncer.current) {
        $9694eec57086f168$var$node = document.createElement('div');
        $9694eec57086f168$var$node.dataset.liveAnnouncer = 'true';
        document.body.prepend($9694eec57086f168$var$node);
        $icz4I$reactdom.render(/*#__PURE__*/ $icz4I$react.createElement($9694eec57086f168$var$LiveRegionAnnouncer, {
            ref: $9694eec57086f168$var$liveRegionAnnouncer
        }), $9694eec57086f168$var$node, ()=>callback($9694eec57086f168$var$liveRegionAnnouncer.current)
        );
    } else callback($9694eec57086f168$var$liveRegionAnnouncer.current);
}
const $9694eec57086f168$var$LiveRegionAnnouncer = /*#__PURE__*/ $icz4I$react.forwardRef((_, ref)=>{
    let [assertiveMessages, setAssertiveMessages] = $icz4I$useState([]);
    let [politeMessages, setPoliteMessages] = $icz4I$useState([]);
    let clear = (assertiveness)=>{
        if (!assertiveness || assertiveness === 'assertive') setAssertiveMessages([]);
        if (!assertiveness || assertiveness === 'polite') setPoliteMessages([]);
    };
    let $9694eec57086f168$export$a9b970dcc4ae71a9 = (message1, assertiveness = 'assertive', timeout = $9694eec57086f168$var$LIVEREGION_TIMEOUT_DELAY)=>{
        let id = $9694eec57086f168$var$messageId++;
        if (assertiveness === 'assertive') setAssertiveMessages((messages)=>[
                ...messages,
                {
                    id: id,
                    text: message1
                }
            ]
        );
        else setPoliteMessages((messages)=>[
                ...messages,
                {
                    id: id,
                    text: message1
                }
            ]
        );
        if (message1 !== '') setTimeout(()=>{
            if (assertiveness === 'assertive') setAssertiveMessages((messages)=>messages.filter((message)=>message.id !== id
                )
            );
            else setPoliteMessages((messages)=>messages.filter((message)=>message.id !== id
                )
            );
        }, timeout);
    };
    $icz4I$useImperativeHandle(ref, ()=>({
            announce: $9694eec57086f168$export$a9b970dcc4ae71a9,
            clear: clear
        })
    );
    return(/*#__PURE__*/ $icz4I$react.createElement($icz4I$Fragment, null, /*#__PURE__*/ $icz4I$react.createElement($9694eec57086f168$var$MessageBlock, {
        "aria-live": "assertive"
    }, assertiveMessages.map((message)=>/*#__PURE__*/ $icz4I$react.createElement("div", {
            key: message.id
        }, message.text)
    )), /*#__PURE__*/ $icz4I$react.createElement($9694eec57086f168$var$MessageBlock, {
        "aria-live": "polite"
    }, politeMessages.map((message)=>/*#__PURE__*/ $icz4I$react.createElement("div", {
            key: message.id
        }, message.text)
    ))));
});
function $9694eec57086f168$var$MessageBlock({ children: children , 'aria-live': ariaLive  }) {
    return(/*#__PURE__*/ $icz4I$react.createElement($icz4I$VisuallyHidden, {
        role: "log",
        "aria-live": ariaLive,
        "aria-relevant": "additions"
    }, children));
}




export {$9694eec57086f168$export$a9b970dcc4ae71a9 as announce, $9694eec57086f168$export$d10ae4f68404609a as clearAnnouncer, $9694eec57086f168$export$d8686216b8b81b2f as destroyAnnouncer};
//# sourceMappingURL=module.js.map
